export enum LabelPinType {
    Default = 'default',
    Plus = 'plus',
    Minus = 'minus',
    PlusMinus = 'plusMinus',
    Sequential = 'sequential', 
    None = 'None'
}
